var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 41,
    viewBox: "0 0 98 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.9552 1.55176H3.86391C2.32921 1.55176 1.08508 2.81712 1.08508 4.37802V36.7463C1.08508 38.3072 2.32921 39.5725 3.86391 39.5725H93.9552C95.4899 39.5725 96.734 38.3072 96.734 36.7463V4.37802C96.734 2.81712 95.4899 1.55176 93.9552 1.55176Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4275 19.8481H12.4364L8.56616 23.812V30.4958H22.2977V23.812L18.4275 19.8481Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7627 19.8481H34.7716L30.9014 23.812V30.4958H44.633V23.812L40.7627 19.8481Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0978 19.8481H57.1067L53.2364 23.812V30.4958H66.968V23.812L63.0978 19.8481Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4291 19.8481H79.4419L75.5716 23.812V30.4958H89.2993V23.812L85.4291 19.8481Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0531 11.4714C88.6494 11.4714 89.1329 10.9797 89.1329 10.3731C89.1329 9.7666 88.6494 9.2749 88.0531 9.2749C87.4567 9.2749 86.9733 9.7666 86.9733 10.3731C86.9733 10.9797 87.4567 11.4714 88.0531 11.4714Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitches);
export default __webpack_public_path__ + "static/media/Switches.ff7bdfc93dcab52d848e6babb1f82246.svg";
export { ForwardRef as ReactComponent };